import { useState, useEffect, useRef, useMemo } from 'react';
import { Box, HStack, Image, Pressable, Text } from 'native-base';
import { useLanguage } from '../contexts/LanguageContext';
import esFlag from '../assets/flags/es.png';
import enFlag from '../assets/flags/en.png';
// import zhFlag from '../assets/flags/zh.png';

interface LanguagePickerProps {
  upper?: boolean;
}

const LanguagePicker = ({ upper = false }: LanguagePickerProps) => {
  const { language, changeLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const languages = [
    { code: 'es' as const, label: 'Español', flag: esFlag },
    { code: 'en' as const, label: 'English', flag: enFlag },
    // { code: 'ch' as const, label: '中文', flag: zhFlag },
  ];

  const currentLanguage = useMemo(() => {
    return languages.find((lang) => lang.code === language) || languages[0];
  }, [language]);

  const handleLanguageChange = (langCode: 'es' | 'en') => {
    changeLanguage(langCode);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <Box 
      position="relative" 
      ref={containerRef}
      //@ts-ignore
      zIndex={10000}
      //@ts-ignore
      style={{ zIndex: 10000, position: 'relative' }}>
      {/*@ts-ignore */}
      <Pressable onPress={() => setIsOpen(!isOpen)}>
        {({ isHovered }) => (
          <HStack
            alignItems="center"
            space={2}
            px={3}
            py={2}
            borderWidth={1}
            borderColor={
              isHovered
                ? upper
                  ? '#ffb31c'
                  : '#293d8b'
                : upper
                ? '#ffffff66'
                : '#e5e7eb'
            }
            borderRadius={8}
            backgroundColor={isHovered ? (upper ? '#ffffff11' : '#f9fafb') : 'transparent'}>
            <Image
              key={currentLanguage.code}
              source={{ uri: currentLanguage.flag }}
              alt={currentLanguage.code}
              width="24px"
              height="24px"
              //@ts-ignore
              style={{
                imageRendering: 'auto',
                objectFit: 'cover',
                borderRadius: '2px'
              }}
            />
            <Text
              color={upper ? '#ffffff' : '#111827'}
              fontSize="15px"
              fontFamily="Segoe UI">
              {currentLanguage.label}
            </Text>
          </HStack>
        )}
      </Pressable>

      {isOpen && (
        <Box
          position="absolute"
          top="45px"
          right={0}
          backgroundColor="#ffffff"
          borderWidth={1}
          borderColor="#e5e7eb"
          borderRadius={8}
          shadow={3}
          //@ts-ignore
          zIndex={10001}
          //@ts-ignore
          style={{ zIndex: 10001, position: 'absolute' }}
          minWidth="140px">
          {languages.map((lang) => (
            <Box
              key={lang.code}
              //@ts-ignore
              as="div"
              //@ts-ignore
              onClick={() => handleLanguageChange(lang.code as 'es' | 'en')}
              //@ts-ignore
              cursor="pointer"
              //@ts-ignore
              _hover={{ backgroundColor: '#f3f4f6' }}
              backgroundColor={
                currentLanguage.code === lang.code
                  ? '#f9fafb'
                  : 'transparent'
              }>
              <HStack
                alignItems="center"
                space={2}
                px={3}
                py={2}>
                <Image
                  source={{ uri: lang.flag }}
                  alt={lang.code}
                  width="24px"
                  height="24px"
                  //@ts-ignore
                  style={{
                    imageRendering: 'auto',
                    objectFit: 'cover',
                    borderRadius: '2px'
                  }}
                />
                <Text fontSize="15px" fontFamily="Segoe UI" color="#111827">
                  {lang.label}
                </Text>
              </HStack>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default LanguagePicker;
